import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { CreditPurchaseService } from "@app/applications/payment/domains/purchase/services/credit-purchase.service";
import { CREDIT_PURCHASE_WITH_PAYMENT_METHOD_DATA_SHAPE } from "@app/applications/payment/domains/purchase/datashapes/credit-purchase.datashape";
import { ICreditPurchase } from "@app/applications/payment/domains/purchase/interfaces/credit-purchase.interface";

export const getCreditPurchaseResolver: ResolveFn<ICreditPurchase> = route => {
  console.log(inject(Router).getCurrentNavigation()?.extras.state);
  return inject(CreditPurchaseService).getCreditPurchase(route.paramMap.get("purchaseId") as string, CREDIT_PURCHASE_WITH_PAYMENT_METHOD_DATA_SHAPE);
};
